<template>
  <div>
    <CheckboxTeamInstruction
      name="counter"
      :value="counter"
      mutation="updateCounter"
      :incompatible="holdShape"
    >
      {{ $t('tactics.instructions.transitions.attacking.counter') }}
    </CheckboxTeamInstruction>

    <CheckboxTeamInstruction
      name="hold-shape"
      :value="holdShape"
      mutation="updateHoldShape"
      :incompatible="counter"
    >
      {{ $t('tactics.instructions.transitions.attacking.holdShape') }}
    </CheckboxTeamInstruction>
  </div>
</template>

<script>
import CheckboxTeamInstruction from "@/components/CheckboxTeamInstruction";

export default {
  components: {
    CheckboxTeamInstruction
  },

  computed: {
    attackingTransition () {
      return this.$store.state.instructions.inTransition.attackingTransition;
    },

    counter () {
      return this.attackingTransition === 1;
    },

    holdShape () {
      return this.attackingTransition === -1;
    }
  }
};
</script>

<style scoped>

</style>
